export const abilities = [
  "form-view",
  "form-send",
  "form-cancel",
  "form-export",
  "form-reschedule",
  "telehealth-view",
  "telehealth-cancel",
  "telehealth-schedule",
  "telehealth-reschedule",
  "telehealth-room-access",
  "events-view",
  "events-schedule",
  "events-cancel",
  "events-reschedule",
  "events-edit",
  "messages-view",
  "messages-send",
  "messages-close",
  "messages-reopen",
  "messages-set-read",
  "library-forms",
  "library-questions",
  "users-manage",
  "roles-manage",
  "locations-manage",
  "billing-view",
  "billing-payment-method",
]